import { render, staticRenderFns } from "./payDelivary.vue?vue&type=template&id=502f23aa"
import script from "./payDelivary.vue?vue&type=script&lang=js"
export * from "./payDelivary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports